// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const OrderHistory: React.FC = () => {
    return <svg width="62px" height="58px" viewBox="0 0 62 58" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="1.-Homepage" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-506.000000, -284.000000)" stroke="#424242" strokeWidth="2">
            <g transform="translate(130.000000, 245.000000)">
                <g transform="translate(330.000000, 40.000000)">
                    <g transform="translate(46.000000, 0.000000)">
                        <path d="M8.07207207e-05,0.403603604 L6.93156901,0.403603604 C7.3109564,0.403603604 7.63787532,0.668367568 7.71698162,1.03887568 L17.3170969,46.3546811 L53.7229492,46.3546811"></path>
                        <path d="M9.98458811,11.747125 L59.2896115,11.747125 C59.8021881,11.747125 60.1831899,12.2201485 60.0734097,12.7198097 L54.7175899,37.1999827 C54.636062,37.5680692 54.3107575,37.8304115 53.9337917,37.8304115 L15.5115359,37.8304115"></path>
                        <path d="M22.4339834,50.7776115 C22.4339834,53.2250638 20.4490609,55.2091791 18.0016086,55.2091791 C15.5541564,55.2091791 13.5700411,53.2250638 13.5700411,50.7776115 C13.5700411,48.3301593 15.5541564,46.3452368 18.0016086,46.3452368 C20.4490609,46.3452368 22.4339834,48.3301593 22.4339834,50.7776115 Z"></path>
                        <path d="M57.8888649,50.7776115 C57.8888649,53.2250638 55.9047495,55.2091791 53.4572973,55.2091791 C51.0090378,55.2091791 49.0249225,53.2250638 49.0249225,50.7776115 C49.0249225,48.3301593 51.0090378,46.3452368 53.4572973,46.3452368 C55.9047495,46.3452368 57.8888649,48.3301593 57.8888649,50.7776115 Z"></path>
                        <polyline points="27.0131892 23.8946249 28.9860036 25.8674393 30.9596252 23.8946249"></polyline>
                        <path d="M28.9334544,25.8740584 C28.6614256,23.7317305 29.3483589,21.4893088 30.9942544,19.8434133 C33.8194796,17.0189953 38.3995733,17.0189953 41.2247986,19.8434133 C44.0492166,22.6686386 44.0492166,27.2487323 41.2247986,30.0739575 C38.7208418,32.5779142 34.8381751,32.8620512 32.021022,30.9279827 C31.6593932,30.6801701 31.3155229,30.3952259 30.9942544,30.0739575"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(OrderHistory);
